import { createApi } from '@reduxjs/toolkit/query/react';
import { API, API_PREFIX } from '../../constants';
import { FileModel, FileUploadParameters } from '../../models/file.model';
import { baseQuery } from './base.query';

interface FileData {
  key: number | string;
  value: FileModel;
}

export const filesApi = createApi({
  reducerPath: 'filesApi',
  baseQuery,
  endpoints: (builder) => ({
    getFilesList: builder.query<FileData[], null>({
      query: () => ({
        url: `${API_PREFIX.NEXTGEN}${API.USER_FILES}`,
      }),
    }),
    uploadFile: builder.mutation<FileModel, FileUploadParameters>({
      query: ({ file, metadata }: FileUploadParameters) => {
        const formData = new FormData();
        formData.append('file', file);
        formData.append('metadata', JSON.stringify(metadata));

        return {
          url: `${API_PREFIX.NEXTGEN}${API.USER_FILES}/upload`,
          method: 'POST',
          contentType: 'multipart/form-data',
          body: formData,
        };
      },
    }),
    downloadFile: builder.mutation<unknown, string>({
      query: (args) => ({
        url: `${API_PREFIX.NEXTGEN}${API.USER_FILES}/${API.DOWNLOAD}/${args}`,
        responseType: 'blob',
        responseHandler: async (response) => {
          return response.blob();
        },
      }),
    }),
    deleteFile: builder.mutation<unknown, string>({
      query: (args) => ({
        url: `${API_PREFIX.NEXTGEN}${API.USER_FILES}/${args}`,
        method: 'DELETE',
      }),
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetFilesListQuery,
  useDeleteFileMutation,
  useDownloadFileMutation,
  useUploadFileMutation,
} = filesApi;
